import { MittwaldAPIV2Client } from "@mittwald/api-client-NEXT";
import { setApiTokenInRequest } from "../interceptors/setApiTokenInRequest.js";
import { setLastEventRequestHeader } from "../interceptors/setLastEventRequestHeader.js";
import { waitForTokenRefresh } from "../interceptors/waitForTokenRefresh.js";
import { setup } from "./cache.js";

export const apiClient = MittwaldAPIV2Client.newUnauthenticated();
apiClient.axios.defaults.baseURL = import.meta.env.VITE_APP_API_URI;

apiClient.axios.interceptors.request.use(waitForTokenRefresh);
apiClient.axios.interceptors.request.use(setLastEventRequestHeader);
apiClient.axios.interceptors.request.use(setApiTokenInRequest);

setup(apiClient.axios);
